import { useSettings } from '../../../hooks/useSettings';
import { useInView } from '../../../hooks/useInView';

const STATIC_FALLBACK = [
  {
    id: 'static-1',
    nombre: 'Kevin Alberto',
    rol: 'Fundador & Mecánico Jefe',
    especialidad: 'Motor y Transmisión',
    experiencia: 'Más de 25 años',
    imagen: 'https://public.readdy.ai/ai/img_res/8ec4e3d3f1ed5803996d03eb8b1c7535.jpg',
  },
  {
    id: 'static-2',
    nombre: 'Adrián Molina',
    rol: 'Jefe de Taller',
    especialidad: 'Diagnóstico Electrónico',
    experiencia: '15 años de experiencia',
    imagen: 'https://public.readdy.ai/ai/img_res/8eedd1e0a85a99e19820c77f1022c822.jpg',
  },
  {
    id: 'static-3',
    nombre: 'Luis Prats',
    rol: 'Especialista en Carrocería',
    especialidad: 'Pintura y Chapa',
    experiencia: '12 años de experiencia',
    imagen: 'https://public.readdy.ai/ai/img_res/a2799d66b4c3de03c2bf1bc9f4a46658.jpg',
  },
  {
    id: 'static-4',
    nombre: 'Marta García',
    rol: 'Atención al Cliente',
    especialidad: 'Gestión y Presupuestos',
    experiencia: '8 años de experiencia',
    imagen: 'https://public.readdy.ai/ai/img_res/8ec4e3d3f1ed5803996d03eb8b1c7535.jpg',
  },
];

const Equipo = () => {
  const { settings, loading } = useSettings();
  const [headerRef, headerInView] = useInView();
  const [gridRef, gridInView] = useInView(0.05);

  const team = settings.equipo && settings.equipo.length > 0
    ? settings.equipo.map((m) => ({
        id: m.id,
        nombre: m.nombre,
        rol: m.rol,
        especialidad: (m as typeof m & { especialidad?: string }).especialidad ?? '',
        experiencia: m.experiencia,
        imagen: m.imagen,
      }))
    : STATIC_FALLBACK;

  return (
    <section className="bg-zinc-950 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div
          ref={headerRef}
          className={`mb-12 transition-all duration-700 ${
            headerInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="w-5 h-px bg-yellow-400" />
            <span className="text-yellow-400 text-[10px] font-bold uppercase tracking-[0.3em]">Las personas detrás del taller</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl uppercase text-white leading-none tracking-wide">
            Nuestro <span className="text-yellow-400">Equipo</span>
          </h2>
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-40">
            <i className="ri-loader-4-line animate-spin text-yellow-400 text-2xl" />
          </div>
        ) : (
          <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {team.map((member, i) => (
              <div
                key={member.id}
                className={`group bg-zinc-900/60 border border-zinc-800 hover:border-yellow-400/25 transition-all duration-500 overflow-hidden cursor-default ${
                  gridInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${i * 0.1}s`, transitionDuration: '600ms' }}
              >
                <div className="relative h-64 overflow-hidden bg-zinc-800">
                  {member.imagen ? (
                    <img
                      alt={member.nombre}
                      src={member.imagen}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-zinc-800">
                      <i className="ri-user-3-line text-5xl text-zinc-600" />
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                  {member.especialidad && (
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <span className="inline-block bg-yellow-400/15 border border-yellow-400/20 text-yellow-400 text-[10px] font-bold px-2.5 py-1 uppercase tracking-wider">
                        {member.especialidad}
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-5">
                  <p className="text-white font-bold text-sm">{member.nombre || 'Sin nombre'}</p>
                  <p className="text-yellow-400/70 text-xs mt-0.5 font-medium">{member.rol}</p>
                  {member.experiencia && (
                    <p className="text-zinc-600 text-xs mt-2 flex items-center gap-1.5">
                      <i className="ri-time-line text-zinc-700" />
                      {member.experiencia}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Equipo;
